import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "custom-form-unknown",
	imports: [ReactiveFormsModule, TranslateModule],
	template: `
		<div class="dynamic-field form-unknown" [formGroup]="group">
			<h1>{{ "general.unknown_component" | translate }}</h1>
		</div>
	`,
	styles: [
		`
			div.form-unknown {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 50px;
				width: 100%;
				background: repeating-linear-gradient(-45deg, #dfdfdf, #dfdfdf 5px, transparent 5px, transparent 10px);
			}
			h1 {
				text-align: center;
				background-color: rgba(249, 249, 251, 0.7);
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnknownComponent {
	@Input() config: any;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
